import { createFileRoute } from '@tanstack/react-router';
import { TermsOfUse } from '@/pages/terms';

export const Route = createFileRoute('/terms')({
  component: TermsOfUse,
});
